import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "../../components/shared/Layout";
import Seo from "../../components/SEO/SEO";
import Breadcrumbs from "../../components/shared/Breadcrumbs";
import FeaturedMedia from "../../components/shared/FeaturedMedia";
import SurveyServiceForm from "../../components/Content/Survey/Forms/SurveyService";
import "../../assets/styles/pages/survey.scss";
import RelatedPosts from "../../components/shared/RelatedPosts";


const page = ({ data }) => {
  const { nextPage, previousPage, page, relatedAll } = data;
  const { title, featuredImage, uri, seo } = page;
  const socialImagePublic = featuredImage?.node?.localFile?.publicURL;
  const socialImage = (/\s/g.test(socialImagePublic) || !socialImagePublic)  ? "/logo.png" : socialImagePublic;

  return (
    <Layout>
      <Seo title={seo.title ?? title} description={seo.metaDesc} socialImage={socialImage}
           breadcrumbs={seo.breadcrumbs.slice(1)} uri={uri}/>
      <Breadcrumbs breadcrumbs={seo.breadcrumbs} pageTitle={seo.title} pageUrl={uri}/>
      <div className={"wrapper"}>
        <h1 className="entry-title" dangerouslySetInnerHTML={{ __html: title }}/>
        {featuredImage && <FeaturedMedia image={featuredImage}/>}
        <SurveyServiceForm/>
        {(previousPage?.uri || nextPage?.uri) &&
        <div className={previousPage?.uri ? "prev-next-wrap" : "prev-next-wrap no-prev"}>
          {previousPage?.uri && <Link className={"gradient-button button-prev"} to={previousPage.uri}>&#8592;&nbsp; ก่อนหน้า</Link>}
          {nextPage?.uri && <Link className={"gradient-button button-next"} to={nextPage.uri}>ต่อไป &nbsp;&#8594;</Link>}
        </div>
        }
        {relatedAll?.edges?.length ?
          <RelatedPosts relatedPosts={relatedAll.edges} /> : null
        }
      </div>
    </Layout>
  );
};

export const query = graphql`
  query pageSurveyServiceQuery($id: String!, $terms: [Int], $nextPage: String, $previousPage: String) {
    page: wpPage(id: { eq: $id }) {
      ...PageContent
    }
    nextPage: wpPage(id: { eq: $nextPage }) {
      title
      uri
    }
    previousPage: wpPage(id: { eq: $previousPage }) {
      title
      uri
    }
    relatedAll: allWpPost(
      sort: {date: DESC}
      limit: 4
      filter: {
        terms: {nodes: {elemMatch: {databaseId: {in: $terms}}}},
        id: {ne: $id}
      }
    ) {
      edges {
        node {
          ...PostPreviewContent
        }
      }
    }
  }
`;

export default page;
